import { useState } from 'react';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UISearchInput from 'UIComponents/input/UISearchInput';
import AccountTable from './AccountTable';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import UIButton from 'UIComponents/button/UIButton';
import FrontendPagination from '../../lib/FrontendPagination';
import { ACCOUNTS_PER_PAGE } from '../constants/AccountPagination';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SearchInputContainer = styled.div.withConfig({
  displayName: "AccountPicker__SearchInputContainer",
  componentId: "sc-1s35o3z-0"
})(["width:370px;"]);
const PaginatorContainer = styled.div.withConfig({
  displayName: "AccountPicker__PaginatorContainer",
  componentId: "sc-1s35o3z-1"
})(["width:275px;"]);
const AccountPicker = ({
  accounts,
  accountsPagination,
  changePage,
  search,
  selectAccount
}) => {
  const [selectedAccount, setSelectedAccount] = useState(null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "justify-between",
      children: [/*#__PURE__*/_jsx(H4, {
        className: "m-top-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-experience-shared-components.accountPicker.header"
        })
      }), accounts.size > ACCOUNTS_PER_PAGE && /*#__PURE__*/_jsx(SearchInputContainer, {
        children: /*#__PURE__*/_jsx(UISearchInput, {
          placeholder: I18n.text('developer-experience-shared-components.accountPicker.searchPlaceholder'),
          onChange: ({
            target: {
              value
            }
          }) => {
            search(value.toLowerCase().trim());
            setSelectedAccount(null);
          }
        })
      })]
    }), /*#__PURE__*/_jsx(AccountTable, {
      accountsPagination: accountsPagination,
      selectedAccount: selectedAccount,
      setSelectedAccount: setSelectedAccount
    }), /*#__PURE__*/_jsxs("div", {
      className: "justify-between",
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        disabled: !selectedAccount,
        onClick: () => selectAccount(selectedAccount),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-experience-shared-components.accountPicker.chooseAccount"
        })
      }), accounts.size > ACCOUNTS_PER_PAGE && /*#__PURE__*/_jsx(PaginatorContainer, {
        className: "p-top-2",
        children: /*#__PURE__*/_jsx(UIPaginator, {
          onPageChange: ({
            target: {
              value
            }
          }) => {
            changePage(value);
          },
          page: accountsPagination.getPage(),
          pageCount: accountsPagination.getPageCount(),
          maxVisiblePageButtons: 4
        })
      })]
    })]
  });
};
AccountPicker.propTypes = {
  /** List of Accounts */
  // @ts-expect-error immutable
  accounts: PropTypes.instanceOf(List).isRequired,
  /** Function to run on page change */
  changePage: PropTypes.func.isRequired,
  /** Pagination Object */
  accountsPagination: PropTypes.instanceOf(FrontendPagination).isRequired,
  /** Function to run on accounts search */
  search: PropTypes.func.isRequired,
  /** Function to run on accounts selection */
  selectAccount: PropTypes.func.isRequired
};
export default AccountPicker;